import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType {
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionBaseAmountExternalTaxi =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    distance: number;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionOtherRate =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.CONTRACT_CORRECTION_RATE;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionFavorableDistance =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionOther =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.BONUS_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionWrongRoute =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionBeingLate =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionIncompatibleCar =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionOther =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContribution =

    | BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionBaseAmountExternalTaxi
    | BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionOtherRate;

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContribution =

    | BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionFavorableDistance
    | BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionOther;

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContribution =

    | BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionWrongRoute
    | BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionBeingLate
    | BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionIncompatibleCar
    | BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionOther;

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContribution =
  | BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContribution
  | BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContribution
  | BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContribution;

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationFleetPartner =
  {
    name: string;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriverUser =
  {
    firstName: string;
    lastName: string;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriverStartingAddress =
  {
    displayName: string;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriver =
  {
    user: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriverUser;
    startingAddress: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriverStartingAddress;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociation =
  {
    driver: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriver;
    fleetPartner: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationFleetPartner | null;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataContract = {
  model: string;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiDriverAssociation: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociation;
  description: string;
};

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder =
  {
    id: string;
    humanId: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrder =
  {
    cargoOrder: BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrder =
  {
    transportingOrder: BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrder;
  };

export type BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntry = {
  humanId: number;
  solvedOrders: BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrder[];
};

export type BillingsPlanEntryTaxiDriverRecalculateResponseData = {
  contract: BillingsPlanEntryTaxiDriverRecalculateResponseDataContract;
  billingNodes: BillingsPlanEntryTaxiDriverRecalculateResponseDataBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverRecalculateResponseDataContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntry: BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntry;
  date: Date;
  passengers: string[];
  rateForDistance: number;
  correctedContractModel: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
};

type BillingsPlanEntryTaxiDriverRecalculateResponse =
  HttpResponse<BillingsPlanEntryTaxiDriverRecalculateResponseData>;

export default BillingsPlanEntryTaxiDriverRecalculateResponse;
